import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import InstallWebPackageManagers from "../install-web-package-managers.mdx";
import Tab from "components/Tab";
import CompositionInstall from "./composition-install.mdx";
import PluginInstall from "./plugin-install.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Start by installing `}<inlineCode parentName="p">{`posthog-js`}</inlineCode>{` using your package manager:`}</p>

    <InstallWebPackageManagers mdxType="InstallWebPackageManagers" />
    <p>{`Next, depending on your Vue version, we recommend initializing PostHog using the composition API or as a plugin.`}</p>

    <Tab.Group tabs={['Vue 3: Composition API', 'Vue 2: Plugins']}>
    <Tab.List>
        <Tab mdxType="Tab">Vue 3: Composition API</Tab>
        <Tab mdxType="Tab">Vue 2: Plugins</Tab>
    </Tab.List>
    <Tab.Panels>
        <Tab.Panel>
            <CompositionInstall mdxType="CompositionInstall" />
        </Tab.Panel>
        <Tab.Panel>
            <PluginInstall mdxType="PluginInstall" />
        </Tab.Panel>
    </Tab.Panels>
    </Tab.Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      